export default [
  {
    path: '/personCenter',
    name: 'personCenter',
    component: () => import('@/views/my/personCenter/PersonCenter.vue'),
    meta: { title: 'app_my_center', zhTitle: '个人中心' }
  },
  {
    path: '/reviseEmail',
    name: 'reviseEmail',
    component: () => import('@/views/my/personCenter/ReviseEmail.vue'),
    meta: { title: '', zhTitle: '绑定邮箱' }
  },
  {
    path: '/reviseMobile',
    name: 'reviseMobile',
    component: () => import('@/views/my/personCenter/ReviseMobile.vue'),
    meta: { title: '', zhTitle: '绑定手机号' }
  },
  {
    path: '/revisePass',
    name: 'revisePass',
    component: () => import('@/views/my/personCenter/RevisePass.vue'),
    meta: { title: 'app_login_pw', zhTitle: '登录密码' }
  },
  {
    path: '/accountAndSafe',
    name: 'accountAndSafe',
    component: () => import('@/views/my/setting/AccountAndSafe.vue'),
    meta: { title: 'app_account_safe', zhTitle: '账号与安全' }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/my/setting/Privacy.vue'),
    meta: { title: 'app_privacy_policy', zhTitle: '隐私协议', ignoreAuth: true }
  },
  {
    path: '/setting',
    name: 'setting',
    component: () => import('@/views/my/setting/Setting.vue'),
    meta: { title: 'app_my_setting', zhTitle: '个人设置' }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('@/views/my/Feedback.vue'),
    meta: { title: 'app_feedback', zhTitle: '问题反馈' }
  },
  {
    path: '/myPublish',
    name: 'myPublish',
    component: () => import('@/views/my/MyPublish.vue'),
    meta: { title: 'app_my_distribute', zhTitle: '我的发布', pageLevel: 2 }
  },
  {
    path: '/myStudy',
    name: 'myStudy',
    component: () => import('@/views/my/MyStudy.vue'),
    meta: { title: 'app_my_studies', zhTitle: '我的学习', pageLevel: 2 }
  },
  {
    path: '/mySurvey',
    name: 'mySurvey',
    component: () => import('@/views/my/MySurvey.vue'),
    meta: { title: 'app_my_survey', zhTitle: '我的调查', pageLevel: 2 }
  },
  {
    path: '/myCollect',
    name: 'myCollect',
    component: () => import('@/views/my/MyCollect.vue'),
    meta: { title: 'pc_common_my_love', zhTitle: '我的收藏', pageLevel: 2 }
  },
  {
    path: '/studyTime',
    name: 'studyTime',
    component: () => import('@/views/my/StudyTime.vue'),
    meta: { title: 'study_time_h5', zhTitle: '学习时长' }
  },
  {
    path: '/topAcademic',
    name: 'topAcademic',
    component: () => import('@/views/my/TopAcademic.vue'),
    meta: { title: 'ranking_h5', zhTitle: '排行榜' }
  },
  {
    path: '/teamStudyList',
    name: 'TeamStudyList',
    component: () => import('@/views/my/teamStudy/teamStudyList.vue'),
    meta: { title: 'pc_my_team', pageLevel: 2 }
  },
  {
    path: '/teamStudySearch',
    name: 'TeamStudySearch',
    component: () => import('@/views/my/teamStudy/teamStudySearch.vue'),
    meta: { title: '', pageLevel: 3 }
  },
  {
    path: '/teamStudyDetail',
    name: 'TeamStudyDetail',
    component: () => import('@/views/my/teamStudy/teamStudyDetail.vue'),
    meta: { title: 'apply_detail_h5', pageLevel: 3 }
  },
  {
    path: '/teamStudyLeanerDetail',
    name: 'TeamStudyLeanerDetail',
    component: () => import('@/views/my/teamStudy/teamStudyLeanerDetail.vue'),
    meta: { title: 'apply_detail_h5', pageLevel: 4 }
  },
  {
    path: '/teamStudyFaceDetail',
    name: 'TeamStudyFaceDetail',
    component: () => import('@/views/my/teamStudy/teamStudyFaceDetail.vue'),
    meta: { title: '', pageLevel: 4 }
  },
  {
    path: '/teamStudyDetailSearch',
    name: 'TeamStudyDetailSearch',
    component: () => import('@/views/my/teamStudy/teamStudyDetailSearch.vue'),
    meta: { title: '', pageLevel: 4 }
  },
  {
    path: '/teamStudyExamResult',
    name: 'TeamStudyExamResult',
    component: () => import('@/views/my/teamStudy/teamStudyExamResult.vue'),
    meta: { title: 'app_check_exam_result', pageLevel: 4 }
  },
  {
    path: '/teamStudySurveyResult',
    name: 'TeamStudySurveyResult',
    component: () => import('@/views/my/teamStudy/teamStudySurveyResult.vue'),
    meta: { title: 'app_survey_result', pageLevel: 4 }
  },
  {
    path: '/examPractise',
    name: 'ExamPractise',
    component: () => import('@/views/exam/examPractise/index.vue'),
    meta: { title: 'app_my_examination', pageLevel: 2 }
  },
  {
    path: '/teachManage/TeachManageList',
    name: 'TeachManagementList',
    component: () => import('@/views/my/teachManage/TeachManagementList.vue'),
    meta: { title: 'teaching_management', zhTitle: '教学管理', isKeepAlive: true }
  },
  {
    path: '/teachManage/MyTeachManage',
    name: 'MyTeachManage',
    component: () => import('@/views/my/teachManage/MyTeachManage.vue'),
    meta: { title: 'User_myLecture', zhTitle: '我的授课', isKeepAlive: true }
  },
  {
    path: '/teachManage/TeachDetail',
    name: 'TeachDetail',
    component: () => import('@/views/my/teachManage/TeachDetail.vue'),
    meta: { title: 'teach_manage_detail', zhTitle: '授课详情' }
  },
  {
    path: '/teachManage/BeautifulMoment',
    name: 'BeautifulMoment',
    component: () => import('@/views/my/teachManage/BeautifulMoment.vue'),
    meta: { title: 'offline_attachments', zhTitle: '精彩瞬间' }
  },
  {
    path: '/teachManage/StudentManage',
    name: 'StudentManage',
    component: () => import('@/views/my/teachManage/StudentManage.vue'),
    meta: { title: 'student_h5', zhTitle: '学员' }
  },
  {
    path: '/teachManage/ScanSign',
    name: 'ScanSign',
    component: () => import('@/views/my/teachManage/ScanSign.vue'),
    meta: { title: 'pc_train_scan_check', zhTitle: '扫码进行签到' }
  },
  {
    path: '/teachManage/TeachManageLive',
    name: 'TeachManageLive',
    component: () => import('@/views/my/teachManage/TeachManageLive.vue'),
    meta: { title: 'teach_manage_detail', zhTitle: 'teach_manage_detail', isKeepAlive: true }
  },
  {
    path: '/teachManage/AddStudent',
    name: 'AddStudent',
    component: () => import('@/views/my/teachManage/AddStudent.vue'),
    meta: { title: 'user_addUser', zhTitle: 'user_addUser' }
  },
  {
    path: '/teachManage/HomeWorkList',
    name: 'HomeWorkList', // 待批阅作业
    component: () => import('@/views/my/teachManage/HomeWorkList.vue'),
    meta: { title: 'User_notReviewed_operation', zhTitle: '待批阅作业', isKeepAlive: true }
  },
  {
    path: '/teachManage/HomeWorkDetail',
    name: 'HomeWorkDetail', // 待批阅作业
    component: () => import('@/views/my/teachManage/HomeWorkDetail.vue'),
    meta: { title: 'homework_details', zhTitle: 'homework_details', isKeepAlive: true }
  },
  {
    path: '/teachManage/HomeWorkCriticism',
    name: 'HomeWorkCriticism', // 待批阅作业
    component: () => import('@/views/my/teachManage/HomeWorkCriticism.vue'),
    meta: { title: 'homework_review', zhTitle: 'homework_review' }
  },
  {
    path: '/teachManage/ExamViewList',
    name: 'ExamViewList', // 待批阅试卷
    component: () => import('@/views/my/teachManage/ExamViewList.vue'),
    meta: { title: 'User_notReviewed_exam', zhTitle: 'User_notReviewed_exam', isKeepAlive: true }
  },
  {
    path: '/teachManage/ExamViewListDetail',
    name: 'ExamViewListDetail', // 待批阅试卷
    component: () => import('@/views/my/teachManage/ExamViewListDetail.vue'),
    meta: { title: '', zhTitle: '' }
  },
  {
    path: '/teachManage/examReview',
    name: 'examReview',
    component: () => import('@/views/my/teachManage/examReview.vue'),
    meta: { title: 'review', zhTitle: 'review' }
  },
  {
    path: '/myArchive',
    name: 'myArchive',
    component: () => import('@/views/my/MyArchive.vue'),
    meta: { title: 'file_archive', zhTitle: 'file_archive' }
  },
  {
    path: '/archiveTeachDetail',
    name: 'ArchiveTeachDetail',
    component: () => import('@/views/my/teachManage/archiveTeachDetail.vue'),
    meta: { title: 'teach_manage_detail', zhTitle: 'teach_manage_detail' }
  },
  {
    path: '/myCertificate',
    name: 'MyCertificate',
    component: () => import('@/views/certificate/myCertificate.vue'),
    meta: { title: 'certificate', zhTitle: 'certificate', pageLevel: 2 }
  }
]
